<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Настройки пользователя
    v-col(cols="12")
      v-card.mb-4(outlined)
        v-card-title Информация о пользователе
        v-card-text
          .d-flex.align-center
            p.subtitle-1.mr-2 Логин: {{ user.username }}
          .d-flex.align-center.mb-4
            p.subtitle-1.mr-2.mb-0 Роль:
            v-chip(v-for="role in user.roles" :key="role" label color="primary") {{ ROLES_NAMES[role] }}
          .d-flex.align-center
            p.subtitle-1.mr-2 Дата регистрации: {{user.created_at}}

      v-card.mb-4(outlined)
        v-card-title Права пользователя
        v-card-text
          v-overlay(:value="loadingActions" absolute)
            v-progress-circular(indeterminate)
          v-checkbox(
            v-model="userActions"
            @change="changeActionType(ACTION_LIST[action])"
            v-for="action in Object.keys(ACTION_LIST)"
            :key="action"
            :label="ACTION_LIST_NAMES[ACTION_LIST[action]]"
            :value="ACTION_LIST[action]"
          )
</template>

<script>
import actionsServices from '@/services/API/actions';
import { ACTION_LIST, ACTION_LIST_NAMES } from '../constants';
import { CRUDUsers } from '@/services/API/user';
import { ROLES_NAMES } from '@/constants';

export default {
  data() {
    return {
      user: {},

      actions: [],
      userActions: [],
      loadingActions: false,

      ROLES_NAMES,
      ACTION_LIST,
      ACTION_LIST_NAMES,
    };
  },
  async created() {
    await this.getUser();
    this.fetchActions();
  },
  methods: {
    async fetchActions() {
      try {
        this.loadingActions = true;
        const response = await actionsServices.get({ 'search[user_id]':this.user.id });
        this.actions = response.data.data;
        this.userActions = this.actions.map(({ type }) => type);
        this.loadingActions = false;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async getUser() {
      const { id } = this.$route.params;
      try {
        const response = await CRUDUsers.get(id);
        this.user = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async changeActionType(action) {
      this.loadingActions =  true;

      if (this.userActions.includes(action)) {
        const response = await actionsServices.create({ 'user_id': this.user.id, 'type': action });
        this.actions.push(response.data.data);
      } else {
        const { id } = this.actions.find(({ type }) => type === action);
        this.actions = this.actions.filter(({ type }) => type !== action);
        await actionsServices.delete(id);
      }
      this.loadingActions =  false;
    },
  },

};
</script>

<style>

</style>
